export const ImageFox = () => (
  <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M221.704 236.022C221.704 275.21 189.235 300.575 149.181 300.575C109.129 300.575 76.662 275.211 76.662 236.022C76.662 196.836 109.129 158.661 149.181 158.661C189.235 158.662 221.704 196.836 221.704 236.022Z"
        fill="#3F1722"/>
      <path
        d="M148.238 300.559C148.551 300.561 148.862 300.576 149.181 300.576C149.939 300.576 150.686 300.55 151.437 300.533L148.985 242.996L148.238 300.559Z"
        fill="#5C2938"/>
      <path d="M111.434 186.186L149.639 280.019L185.38 184.452C185.381 184.452 145.326 158.456 111.434 186.186Z"
            fill="#E8DFCE"/>
      <path
        d="M199.122 252.892L192.326 243.027C189.826 239.398 186.74 239.879 185.468 244.099L183.638 250.149L183.102 251.922L181.997 255.565L179.684 263.232L187.6 261.998L195.755 260.725L203.668 259.486L199.122 252.892Z"
        fill="white"/>
      <path d="M205.333 257.92L177.799 262.22L178.77 268.432L206.303 264.132L205.333 257.92Z" fill="#5C2938"/>
      <path
        d="M149.766 270.391C149.766 270.391 133.492 241.915 124.452 210.276C116.467 182.319 115.412 164.172 115.412 164.172L84.2229 188.13C84.2229 188.13 89.1009 199.866 99.9539 217.843L121.29 228.357L113.53 238.598C129.199 260.333 149.767 281.243 149.767 281.243V270.391H149.766Z"
        fill="#5C2938"/>
      <path
        d="M148.735 270.391C148.735 270.391 165.007 241.915 174.047 210.276C182.037 182.319 183.087 164.172 183.087 164.172L214.279 188.13C214.279 188.13 209.399 199.866 198.548 217.843L177.215 228.357L184.973 238.598C169.304 260.333 148.736 281.243 148.736 281.243V270.391H148.735Z"
        fill="#5C2938"/>
      <path
        d="M95.646 50.28C95.646 50.28 71.064 21.732 31.014 15.784C31.014 15.784 23.086 13.801 24.275 27.283C25.462 40.765 30.619 69.314 50.84 90.33C50.84 90.329 94.851 65.745 95.646 50.28Z"
        fill="#E37C2F"/>
      <path
        d="M52.823 83.589C52.823 83.589 39.341 64.952 35.375 40.764C35.375 40.764 33.392 33.23 40.133 36.402C46.876 39.574 67.098 49.089 79.788 60.589L52.823 83.589Z"
        fill="#FFAE5E"/>
      <path opacity="0.49"
            d="M252.632 99.497C252.632 60.308 206.315 34.945 149.18 34.945C92.048 34.945 45.73 60.308 45.73 99.497C45.73 138.687 92.047 207.703 149.18 207.703C206.315 207.704 252.632 138.687 252.632 99.497Z"
            fill="#442282"/>
      <path
        d="M203.038 50.28C203.038 50.28 227.62 21.732 267.672 15.784C267.672 15.784 275.602 13.801 274.411 27.283C273.222 40.765 268.065 69.314 247.844 90.33C247.843 90.329 203.832 65.745 203.038 50.28Z"
        fill="#E37C2F"/>
      <path
        d="M245.862 83.589C245.862 83.589 259.344 64.952 263.308 40.764C263.308 40.764 265.296 33.23 258.552 36.402C251.811 39.574 231.585 49.089 218.897 60.589L245.862 83.589Z"
        fill="#FFAE5E"/>
      <path
        d="M46.0509 99.497C46.0509 60.308 92.3679 34.945 149.505 34.945C206.635 34.945 252.952 60.308 252.952 99.497C252.952 138.687 206.635 207.703 149.505 207.703C92.3679 207.704 46.0509 138.687 46.0509 99.497Z"
        fill="#D16A01"/>
      <path
        d="M149.505 34.946C127.662 34.946 107.412 38.663 90.7169 45.432C93.1069 47.98 140.584 99.747 133.025 186.045H146.895H151.79H165.657C157.949 97.996 207.527 45.891 208.058 45.335C191.407 38.627 171.243 34.946 149.505 34.946Z"
        fill="#E37C2F"/>
      <path
        d="M214.108 53.713C212.85 63.314 188.227 67.955 161.471 63.281C134.708 58.608 114.965 50.427 116.627 35.799C117.73 26.174 140.831 21.854 167.592 26.532C194.352 31.204 215.891 40.134 214.108 53.713Z"
        fill="#5C2938"/>
      <path
        d="M129.088 33.838C126.545 41.767 145.01 47.555 164.507 50.959C183.147 54.215 202.112 52.208 202.906 45.107C202.906 45.107 200.358 19.105 190.242 5.961C190.242 5.961 188.453 2.692 182.24 4.416C176.032 6.137 170.324 7.504 163.875 2.981C157.428 -1.543 154.825 0.660997 149.477 5.932C144.121 11.2 130.387 29.78 129.088 33.838Z"
        fill="#5C2938"/>
      <path
        d="M166.069 37.786C145.357 34.753 137.707 28.347 134.894 24.336C131.916 28.59 129.586 32.283 129.088 33.838C126.545 41.767 145.01 47.555 164.507 50.959C183.147 54.215 202.112 52.208 202.906 45.107C202.906 45.107 202.439 40.43 201.145 34.065C196.533 37.64 186.9 40.839 166.069 37.786Z"
        fill="white"/>
      <path
        d="M142.448 207.312C142.448 207.312 148.792 198.985 131.743 181.936C114.692 164.884 89.315 152.986 61.557 147.833C61.557 147.833 46.486 146.249 56.005 160.127C65.136 173.439 85.778 192.56 113.898 204.935C133.724 213.66 142.448 207.312 142.448 207.312Z"
        fill="#FFAE5E"/>
      <path opacity="0.49"
            d="M80.015 125.112C80.015 125.112 100.616 109.049 111.738 133.255C111.738 133.254 93.076 155.394 80.015 125.112Z"
            fill="#442282"/>
      <path
        d="M80.015 125.112C80.015 125.112 100.616 109.049 111.738 133.255C111.738 133.254 93.076 155.394 80.015 125.112Z"
        fill="white"/>
      <path
        d="M85.1701 129.447C83.539 122.62 87.7461 115.759 94.5691 114.124C101.399 112.489 108.257 116.701 109.891 123.527C111.53 130.354 107.315 137.213 100.49 138.851C93.665 140.48 86.804 136.281 85.1701 129.447Z"
        fill="#19173E"/>
      <path
        d="M95.598 125.494C95.179 123.726 93.397 122.635 91.629 123.061C89.856 123.482 88.766 125.264 89.189 127.034C89.617 128.803 91.39 129.89 93.162 129.472C94.933 129.044 96.026 127.269 95.598 125.494Z"
        fill="white"/>
      <path
        d="M103.774 130.317C103.47 129.054 102.2 128.273 100.934 128.576C99.669 128.881 98.889 130.149 99.195 131.416C99.494 132.681 100.767 133.462 102.03 133.155C103.301 132.851 104.078 131.584 103.774 130.317Z"
        fill="white"/>
      <path
        d="M156.237 207.312C156.237 207.312 149.893 198.985 166.942 181.936C183.994 164.884 209.37 152.986 237.129 147.833C237.129 147.833 252.197 146.249 242.681 160.127C233.552 173.439 212.906 192.56 184.788 204.935C164.959 213.66 156.237 207.312 156.237 207.312Z"
        fill="#FFAE5E"/>
      <path opacity="0.49"
            d="M218.668 125.112C218.668 125.112 198.067 109.049 186.948 133.255C186.948 133.254 205.607 155.394 218.668 125.112Z"
            fill="#442282"/>
      <path
        d="M218.668 125.112C218.668 125.112 198.067 109.049 186.948 133.255C186.948 133.254 205.607 155.394 218.668 125.112Z"
        fill="white"/>
      <path
        d="M213.513 129.447C215.147 122.62 210.937 115.759 204.114 114.124C197.287 112.489 190.426 116.701 188.792 123.527C187.156 130.354 191.368 137.213 198.195 138.851C205.021 140.48 211.879 136.281 213.513 129.447Z"
        fill="#19173E"/>
      <path
        d="M203.085 125.494C203.504 123.726 205.286 122.635 207.054 123.061C208.827 123.482 209.918 125.264 209.494 127.034C209.066 128.803 207.293 129.89 205.521 129.472C203.753 129.044 202.657 127.269 203.085 125.494Z"
        fill="white"/>
      <path
        d="M194.911 130.317C195.213 129.054 196.483 128.273 197.748 128.576C199.013 128.881 199.793 130.149 199.489 131.416C199.188 132.681 197.915 133.462 196.652 133.155C195.383 132.851 194.607 131.584 194.911 130.317Z"
        fill="white"/>
      <path
        d="M131.059 195.757C131.059 188.769 139.317 184.251 149.503 184.251C159.691 184.251 167.944 188.77 167.944 195.757C167.944 202.742 159.691 215.047 149.503 215.047C139.317 215.048 131.059 202.742 131.059 195.757Z"
        fill="#3F1722"/>
      <path
        d="M154.888 224.21C154.888 220.966 152.257 218.337 149.018 218.337C145.774 218.337 143.148 220.966 143.148 224.21C143.148 227.449 145.774 230.08 149.018 230.08C152.256 230.08 154.888 227.449 154.888 224.21Z"
        fill="#4A5F71"/>
      <path
        d="M152.108 221.877C152.108 221.877 168.444 215.215 175.353 212.727C182.264 210.239 184.522 214.083 184.654 218.263C184.788 222.442 183.188 234.532 179.604 239.84C176.013 245.148 169.492 240.687 167.114 239.388C161.933 236.563 151.441 226.171 151.441 226.171L152.108 221.877Z"
        fill="#4A5F71"/>
      <path
        d="M145.613 221.877C145.613 221.877 129.277 215.215 122.368 212.727C115.457 210.239 113.199 214.083 113.067 218.263C112.933 222.442 114.533 234.532 118.114 239.84C121.707 245.148 128.228 240.687 130.604 239.388C135.788 236.563 146.28 226.171 146.28 226.171L145.613 221.877Z"
        fill="#4A5F71"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="300" height="300" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
